import Vue from "vue";
import { AbacoWebModule, ApplicationReadyEvent, VueRouter } from "@abaco/web-common/src/app";
import GlobalStateVuexModule from "./state";
import PlotApi from "./api/PlotApi";
import ImportApi from "./api/ImportApi";
import globals from "./globals";
import { HTTPClient } from "@abaco/web-common/src/HTTP";
import FarmerRegistryModule from "@abaco/farm-registry/src/modules/farm-registry/index";
import SSOModule from "@abaco/sso-web-module/src/abaco-module";
import MapModule from "@abaco/map-web-module/src/modules/map-web-module";
import { RouterReadyEvent } from "@abaco/web-common/src/app/Application";


export const MODULE_ID = "global_state";
export const MAX_PLOT_COUNT_BEFORE_OPTIMIZATION = 1000;
const state = new GlobalStateVuexModule();

export default class GlobalStateModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;
    private pltApi!: PlotApi;
    private imprtApi!: ImportApi;

    readonly id = MODULE_ID;
    readonly vuexModule = state;
    readonly globalComponents = globals;

    private farmRegistryModule!: FarmerRegistryModule;
    private ssoModule!: SSOModule;
    private mapWebModule!: MapModule;
    private apiCreated = false;
    private router!: VueRouter;

    dependsOn = {
        [FarmerRegistryModule.MODULE_ID]: () => new FarmerRegistryModule(),
    };

    onRouterReady(event: RouterReadyEvent) {
        this.router = event.router;
    }

    onApplicationReady(evt: ApplicationReadyEvent) {
        const farmRegistryModule = evt.modules.find((m) => m.id === FarmerRegistryModule.MODULE_ID) as
            | FarmerRegistryModule
            | undefined;
        const ssoModule = evt.modules.find((m) => m.id === SSOModule.MODULE_ID) as SSOModule | undefined;
        const mapWebModule = evt.modules.find((m) => m.id === MapModule.MODULE_ID) as MapModule | undefined;

        if (!farmRegistryModule) {
            throw new Error("FarmRegistryModule not found!");
        }
        if (!ssoModule) {
            throw new Error("SsoModule not found!");
        }
        if (!mapWebModule) {
            throw new Error("MapWebModule not found!");
        }

        this.farmRegistryModule = farmRegistryModule;
        this.ssoModule = ssoModule;
        this.mapWebModule = mapWebModule;

        this.router.beforeEach((to, from, next) => {
            if (this.vuexModule.curPlot?.plot_subject_id != this.farmRegistryModule.vuexModule.farm?.pk_cuaa) {
                this.vuexModule.curPlot = null;
                this.vuexModule.curBlock = null;
                this.vuexModule.curPlotGroup = null;
            }
            next();
        });

        Vue.filter("only4Digits", (val: number, additionalText: string) => {
            return `${Number(val).toLocaleString(ssoModule.vuexModule.user?.locale, {
                minimumFractionDigits: 4,
                maximumFractionDigits: 4
            })} ${additionalText}`;
        });
    }

    async beforeEnterAnyRoutes(http: HTTPClient) {
        if (this.pltApi) {
            return;
        }
        this.apiCreated = true;
        const PlotApi = (await import("./api/PlotApi")).default;
        this.pltApi = new PlotApi(http, this.vuexModule, this.farmRegistryModule, this.ssoModule, this.mapWebModule, MAX_PLOT_COUNT_BEFORE_OPTIMIZATION);

        const ImportApi = (await import("./api/ImportApi")).default;
        this.imprtApi = new ImportApi(http);
    }

    get plotApi() {
        return this.pltApi;
    }

    get importApi() {
        return this.imprtApi;
    }
}
